import AuthServiceRepository from "../../ports/authServiceRepository";

export type loginUsecase = (
  email: string,
  password: string
) => Promise<{
  user: {
    token: string;
    id: string;
    isAdmin: boolean;
    isSuperAdmin: boolean;
    name: string;
    email: string;
  } | null;
}>;

export const buildLogin = (dependencies: {
  authServiceRepo: AuthServiceRepository;
}): loginUsecase => {
  const { authServiceRepo } = dependencies;

  const login: loginUsecase = async (email: string, password: string) =>
    authServiceRepo.login(email, password);

  return login;
};
